<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove {{hspr.fctitaal_oms}} {{hspr.hspr_bedrag}} from booking {{hspr.huov_code}} ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmHspr">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      hspr_encrid: null,
      hspr: {}
    }
  },
  methods: {
    open(hspr_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huov/hspr/getHspr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHspr"
          },
          getHspr: {
            hspr_encrid: hspr_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hspr = res.data.getHspr;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmHspr() { 
      this.$axios
        .post("ares/json/ares/huov/hspr/rmHspr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmHspr"
          },
          rmHspr: {
            hspr_encrid: this.hspr.hspr_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$router.reload('/huov/onHuov/' + res.data.rmHspr.huov_encrid); 
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmHspr.text,
              color: res.data.rmHspr.color
            });
            
            this.dialog = false;
          }
        })
    },
  }
}
</script>

